

module.exports = __webpack_require__.stylable.create(
    "inputwithoptions2222937164",
    {"classes":{"root":"inputwithoptions2222937164__root","inputComponent":"inputwithoptions2222937164__inputComponent"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    4,
    /*! ../node_modules/wix-ui-core/dist/src/components/input-with-options/InputWithOptions.st.css */ 347,
    null
);
